import { useState } from "react";
import { Search, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PageHeader, EmptyState, Tag, BookCover, DemoBadge } from "@/components/lf";
import { CATALOG, rupiah } from "@/lib/catalog";
import { addToCart } from "@/lib/cart";

export default function TokoBuku() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [sort, setSort] = useState("judul");
  const [detail, setDetail] = useState(null);

  const cats = [...new Set(CATALOG.map((b) => b.category))];
  const shown = CATALOG
    .filter((b) => !cat || b.category === cat)
    .filter((b) => !q || `${b.title} ${b.author} ${b.description}`.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => (sort === "harga-asc" ? a.price - b.price : sort === "harga-desc" ? b.price - a.price : a.title.localeCompare(b.title)));

  const add = (b) => {
    try { addToCart(b.id); toast.success(`“${b.title}” masuk keranjang.`); } catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <PageHeader testid="page-title-toko" overline="Toko fisik" title="Toko Buku" subtitle="Katalog demonstrasi. Harga dan stok hanyalah contoh; tidak ada transaksi nyata.">
        <DemoBadge>HARGA CONTOH — DEMONSTRASI</DemoBadge>
      </PageHeader>

      <div className="flex flex-col md:flex-row gap-3 mb-8" data-testid="store-toolbar">
        <div className="relative flex-1"><Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#929197]" /><input data-testid="store-search-input" className="lf-field !pl-9" placeholder="Cari judul atau penulis…" value={q} onChange={(e) => setQ(e.target.value)} /></div>
        <select data-testid="store-category-filter" className="lf-field md:w-52" value={cat} onChange={(e) => setCat(e.target.value)}><option value="">Semua kategori</option>{cats.map((c) => <option key={c}>{c}</option>)}</select>
        <select data-testid="store-sort-select" className="lf-field md:w-52" value={sort} onChange={(e) => setSort(e.target.value)}><option value="judul">Judul A–Z</option><option value="harga-asc">Harga terendah</option><option value="harga-desc">Harga tertinggi</option></select>
      </div>

      {shown.length === 0 ? <EmptyState testid="store-empty" title="Buku tidak ditemukan" text="Coba kata kunci atau kategori lain." /> : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="store-grid">
          {shown.map((b) => (
            <div key={b.id} className="lf-card lf-card-hover p-5 flex flex-col" data-testid="store-item">
              <button onClick={() => setDetail(b)} aria-label={`Detail ${b.title}`}><BookCover book={b} /></button>
              <div className="mt-4 flex-1">
                <Tag>{b.category}</Tag>
                <h3 className="font-serif text-2xl mt-2 leading-tight">{b.title}</h3>
                <div className="text-sm text-[#929197]">{b.author}</div>
              </div>
              <div className="flex items-end justify-between mt-4">
                <div><div className="font-serif text-2xl" data-testid="store-item-price">{rupiah(b.price)}</div><div className="text-[10px] uppercase tracking-widest text-[#d4a95f]">Harga demonstrasi</div></div>
                {b.stock > 0 ? <Tag tone="blue">Tersedia ({b.stock})</Tag> : <Tag tone="red">Stok habis</Tag>}
              </div>
              <div className="flex gap-2 mt-4">
                <button data-testid="store-detail-button" onClick={() => setDetail(b)} className="lf-btn-ghost !py-2 flex-1">Detail</button>
                <button data-testid="store-add-to-cart" disabled={b.stock <= 0} onClick={() => add(b)} className="lf-btn !py-2 flex-1"><ShoppingCart size={14} />Keranjang</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {detail && (
        <Dialog open onOpenChange={(o) => !o && setDetail(null)}>
          <DialogContent data-testid="store-detail-dialog" className="bg-[#1B1B1F] border-[#29292D] text-[#F2F0EC] max-w-3xl max-h-[90vh] overflow-y-auto">
            <DialogHeader><DialogTitle className="font-serif text-3xl font-medium">{detail.title}</DialogTitle><DialogDescription className="text-[#929197]">{detail.author} · {detail.pages} halaman (perkiraan)</DialogDescription></DialogHeader>
            <div className="grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-6">
              <BookCover book={detail} />
              <div>
                <p className="text-sm leading-relaxed">{detail.description}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">{detail.topics.map((t) => <Tag key={t} tone="blue">{t}</Tag>)}</div>
                <div className="mt-5 font-serif text-3xl">{rupiah(detail.price)}</div>
                <div className="text-[10px] uppercase tracking-widest text-[#d4a95f] mb-4">Harga demonstrasi · sampul placeholder</div>
                <button data-testid="store-detail-add-to-cart" disabled={detail.stock <= 0} onClick={() => { add(detail); setDetail(null); }} className="lf-btn"><ShoppingCart size={14} />{detail.stock > 0 ? "Tambah ke keranjang" : "Stok habis"}</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
